// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lpwz","name":"styles_name__3IGCV","phone":"styles_phone__3IkDH"};